<template>
  <div class="container-fluid py-4">
    <form @submit.prevent="search" role="form" class="text-start mt-3">
      <div class="row align-items-center">
        <div class="col-lg-9 col-sm-9">
          <material-input
            id="search"
            type="text"
            label="Search here"
            v-model="key_word"
          />
        </div>
        <div class="col-lg-3 col-sm-3">
          <material-button
            class="btn btn-primary toast-btn"
            variant="gradient"
            color="success"
            fullWidth
            type="submit"
          >
            Search
          </material-button>
        </div>
      </div>
    </form>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      ID
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Code
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Merchant Name
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Logo
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Parent Company ID
                    </th>
                    <th
                      class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Status
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Created Date
                    </th>
                    <th
                      class="text-uppercase text-center text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="merchant in listMerchant" :key="merchant.id">
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs font-weight-bold mb-0">
                        {{ merchant.id }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs font-weight-bold mb-0">
                        {{ merchant.merchant_code }}
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ merchant.brand_name }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <img
                        v-if="merchant.logo"
                        :src="merchant.logo"
                        class="avatar avatar-sm border-radius-lg"
                        :alt="merchant.brand_name"
                      />
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ merchant.parent_merchant_name || '-' }}
                      </p>
                    </td>
                    <td class="align-middle text-left text-sm">
                      <span
                        :class="[
                          merchant.status == 1 ? 'bg-success' : 'bg-secondary',
                          'badge badge-sm',
                        ]"
                      >
                        {{ merchant.status ? "Active" : "Deactive" }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs font-weight-bold mb-0">
                        {{ merchant.created_at_format }}
                      </p>
                    </td>
                    <td class="w-20 align-middle text-left text-sm">
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="editMerchant(merchant.id)"
                      >
                        <i
                          class="fas fa-pencil-alt text-dark me-2"
                          aria-hidden="true"
                        ></i>
                        Edit
                      </a>
                      <a
                        v-if="merchant.status"
                        class="btn btn-link text-danger px-3 mb-0"
                        href="javascript:;"
                        @click="deactiveMerchant(merchant)"
                      >
                        Deactive
                      </a>
                      <a
                        v-else
                        class="btn btn-link text-success px-3 mb-0"
                        href="javascript:;"
                        @click="activeMerchant(merchant)"
                      >
                        Active
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pagination
      v-if="pagination.last_page > 1"
      :pagination="pagination"
      :current_page="pagination.current_page"
      :last_page="pagination.last_page"
      @page-changed="getList"
    />
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="deleteModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-normal" id="exampleModalLabel">
            Are you sure you want to delete this merchant?
          </h5>
          <button
            type="button"
            class="btn-close text-dark"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-footer">
          <material-button
            class="btn bg-gradient-secondary"
            data-bs-dismiss="modal"
          >
            No
          </material-button>
          <material-button
            class="btn bg-gradient-primary"
            @click="deleteMer"
            data-bs-dismiss="modal"
          >
            Yes
          </material-button>
        </div>
      </div>
    </div>
  </div>

  <div class="position-fixed top-1 end-1 z-index-2 message-success">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title=""
      date=""
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>

  <!-- Loading centered on page -->
  <material-loading :active="loaderActive" class="centered-loader" />
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MerchantService from "../../services/merchant.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Pagination from "@/components/Pagination.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";

export default {
  name: "admin-merchants",
  components: {
    MaterialInput,
    MaterialButton,
    MaterialSnackbar,
    Pagination,
    MaterialLoading,
  },
  data() {
    return {
      listMerchant: [],
      merchantId: null,
      key_word: "",
      snackbar: null,
      message: "",
      pagination: {},
      page: 1,
      loaderActive: false,
    };
  },
  mounted() {
    this.checkCreatedStatus();
    this.getList(this.page);
  },
  methods: {
    checkCreatedStatus() {
      const created = this.$route.query.created;
      if (created) {
        this.showSuccessMessage("Merchant created successfully!");
        this.$router.replace({ query: {} });
      }
    },

    async getList(page) {
      this.showLoader();
      try {
        const dataForm = {
          search_keyword: this.key_word,
          page: page,
        };
        
        const response = await MerchantService.getListMerchant(dataForm);
        
        this.listMerchant = response.data.data.items;
        this.pagination = response.data.data;
        this.page = this.pagination.current_page;
      } catch (error) {
        console.error("Error fetching merchants:", error);
        this.showErrorMessage("Failed to load merchants");
      } finally {
        this.hideLoader();
      }
    },

    async search() {
      await this.getList(1); // Reset to first page when searching
    },

    setMerchantId(id) {
      this.merchantId = id;
    },

    async deleteMer() {
      if (!this.merchantId) return;
      
      this.showLoader();
      try {
        const response = await MerchantService.deleteMerchant(this.merchantId);
        
        if (response.data.result.isSuccess) {
          await this.getList(this.page);
          this.showSuccessMessage("Merchant deleted successfully!");
        }
      } catch (error) {
        console.error("Error deleting merchant:", error);
        this.showErrorMessage("Failed to delete merchant");
      } finally {
        this.hideLoader();
      }
    },

    async deactiveMerchant(merchant) {
      await this.updateMerchantStatus(merchant, 0);
    },

    async activeMerchant(merchant) {
      await this.updateMerchantStatus(merchant, 1);
    },

    async updateMerchantStatus(merchant, status) {
      this.showLoader();
      try {
        const response = await MerchantService.updateMerchantStatus(merchant.id, status);

        if (response.data.result.isSuccess) {
          await this.getList(this.page);
          this.showSuccessMessage(
            `Merchant ${status ? 'activated' : 'deactivated'} successfully!`
          );
        }
      } catch (error) {
        console.error("Error updating merchant:", error);
        this.showErrorMessage("Failed to update merchant status");
      } finally {
        this.hideLoader();
      }
    },

    editMerchant(id) {
      this.$router.push(`/admin/merchant-detail/${id}?page=${this.page}`);
    },

    showSuccessMessage(message) {
      this.snackbar = "success";
      this.message = message;
      this.setTimeOutNotification();
    },

    showErrorMessage(message) {
      this.snackbar = "danger";
      this.message = message;
      this.setTimeOutNotification();
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>